import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CasillaActualService } from 'src/app/services/casilla-actual.service';

import { AppStore } from 'src/app/core/store/app.store';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  readonly state$ = this.appStore.state$;

  usuario: string
  sessionUser = this.appStore.state.session.user;

  constructor(
    private appStore: AppStore,
    private router: Router,
    private route: ActivatedRoute,
    private casillaActual: CasillaActualService
  ) { }

  ngOnInit() {
    
    /*if (this.appStore.sessionAction.esSesionValida()) 
    {

      this.appStore.sessionAction.restablecerSesionDeLocalStorage();
      this.sessionUser = this.appStore.state.session.user;
      this.usuario = this.sessionUser.Name;
      //this.router.navigate(['/dashboard/']);
    }
    else 
    {
      let token = this.route.snapshot.queryParamMap.get('token');
      //console.log(token);
      if(token) {
        this.casillaActual.setSesion(token);
        
        this.router.navigate(['/dashboard/']);
      }
      else {
        this.router.navigate(['/login/']);
      }
    }*/
  }

  handleCambioClave = () => {
    this.appStore.sessionAction.restablecerSesionDeLocalStorage();
    //console.log(this.appStore.sessionAction.getUserSesion());
    //console.log(this.appStore.sessionAction.isToken());
    let token = this.route.snapshot.queryParamMap.get('token');
    //console.log(token);
    this.router.navigate(['/cambio-clave/']);
    //console.log(this.selectedTipoRegistro);
  }

  handleCerrarSeision = () => {
    this.appStore.sessionAction.logout();
    this.router.navigate(['/login/']);
  }

  /*handleSiFirma = () => {
    console.log(this.appStore.sessionAction.getUserSesion());
    //let token = this.route.snapshot.queryParamMap.get('token');
    let token = this.appStore.sessionAction.isToken();
    location.href = "http://sifirmademo.pvn.gob.pe/?token=" + token; //environment.loginUrl + window.location.origin;
    
  }*/
}
